import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";
import useExportAction from "@beeldit/ecommerce/super-orders/actions/export/useExportAction";
import useCancelAction from "@beeldit/ecommerce/super-orders/actions/cancel/useCancelAction";
import { ShoppingCart } from "@phosphor-icons/react";
import useRequestInvoiceAction from "@beeldit/ecommerce/super-orders/actions/request-invoice/useRequestInvoiceAction";

function SuperOrdersPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { detailsFunction } = useDetailsAction(0);

  const { prepareCancelFunction, actionTemplate: cancelActionTemplate } =
    useCancelAction(indexFunction);

  const { exportFunction, actionTemplate: exportActionTemplate } =
    useExportAction(filters);

  const {
    showModalRequestInvoice,
    actionTemplate: requestInvoiceActionTemplate,
  } = useRequestInvoiceAction(indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        detailsFunction,
        indexFunction,
        exportFunction,
        prepareCancelFunction,
        showModalRequestInvoice,
        /**newActionsTableConfig**/
      }),
    [
      detailsFunction,
      indexFunction,
      exportFunction,
      prepareCancelFunction,
      showModalRequestInvoice,
    ]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <ShoppingCart size={24} /> {t("super_orders")}
        </Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {exportActionTemplate}
        {cancelActionTemplate}
        {requestInvoiceActionTemplate}
      </Card.Body>
    </Card>
  );
}

export default SuperOrdersPage;
